import React, { Component } from "react";
import styles from "./cmsUnitSettings.module.scss";
import CmsUnitSettingItem from "./CmsUnitSettingItem";
import Scrollbars from "react-custom-scrollbars-2";
import CmsUnitSettingGroupItem from "./CmsUnitSettingGroupItem";
import { withUnits } from "../../../../shared/containers/containerUnits";
import ButtonPrimary from "../../../../shared/items/contols/buttonPrimary";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import { v4 as uuidv4 } from "uuid";

class CmsUnitSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settingsGroup: [],
      settings: [],
      needUpdate: false,
    };
  }

  componentDidMount() {
    const settings = this.getSettingsByGroupIndex();

    this.setState({
      settingsGroup: this.getSettings(settings),
      settings: settings,
      needUpdate: false,
    });
  }

  componentDidUpdate(prevPeops) {
    const { updateUnitSettingDataState } = this.props;
    const { settings } = this.state;

    const updating = () => {
      return settings.some((x) => {
        if (x.item.forUpdate) return true;

        return x.dependents.some((d) => {
          return d.forUpdate;
        });
      });
    };

    if (updateUnitSettingDataState === states.READY && prevPeops.updateUnitSettingDataState === states.REQUEST) {

      if (updating()) {
        this._onhandleUpdate();
      } else {
        const _settings = this.getSettingsByGroupIndex();

        this.setState({
          settingsGroup: this.getSettings(_settings),
          settings: _settings,
        });
      }
    }
  }

  getSettingsByGroupIndex() {
    const { unitSettings, indexGroup } = this.props;

    if (unitSettings.settingsGroups === undefined || unitSettings.settingsGroups.length === 0) {
      return [];
    }

    return JSON.parse(JSON.stringify(unitSettings.settingsGroups.filter((x) => x.group === indexGroup)[0].settings));
  }

  getSettings(settings) {
    const _settings = [];

    for (let i = 0; i < settings.length; i += 3) {
      _settings.push({
        left: settings[i],
        middle: i + 1 < settings.length ? settings[i + 1] : null,
        rigth: i + 2 < settings.length ? settings[i + 2] : null,
      });
    }

    return _settings;
  }

  onHancleChange(setting) {
    const { settings } = this.state;
    const { onChangeSetting } = this.props;

    const _settings = settings.map((x) => {
      if (setting.id === x.item.id) {
        setting.forUpdate = true;

        return { dependents: x.dependents, item: setting };
      }

      x.dependents = x.dependents.map((d) => {
        if (setting.id === d.id) {
          setting.forUpdate = true;

          return setting;
        }

        return d;
      });

      return x;
    });

    this.setState({
      settingsGroup: this.getSettings(_settings),
      settings: _settings,
      needUpdate: true,
    });

    onChangeSetting(true);
  }

  _onhandleUpdate() {
    const { settings } = this.state;
    const { onUpdatgeUnitSetting, currentUnit } = this.props;

    let setUpdate = false;

    settings.forEach((x) => {
      if (x.item.forUpdate && !setUpdate) {
        onUpdatgeUnitSetting(currentUnit.id, x.item);
        x.item.forUpdate = false;
        setUpdate = true;
      }

      x.dependents.forEach((d) => {
        if (d.forUpdate && !setUpdate) {
          onUpdatgeUnitSetting(currentUnit.id, d);
          d.forUpdate = false;
          setUpdate = true;
        }
      });
    });

    this.setState({ settings: settings });
  }

  onhandleUpdate() {
    const { onChangeSetting } = this.props;

    this._onhandleUpdate();

    onChangeSetting(false);
    this.setState({
      needUpdate: false,
    });
  }

  componentDidCatch(value) {
    console.error(value);
  }

  render() {
    const { height = 450, updateUnitSettingDataState } = this.props;
    const { settingsGroup, needUpdate } = this.state;
    const styleColumn = { width: "33%", borderRight: "10px solid #ffffff", borderBottom: "3px solid #ffffff" };
    // if (updateUnitSettingDataState === states.REQUEST) return null;

    return (
      <div className={styles.unitSettingsContainer}>
        <div className={styles.updateButtonContainer} key={uuidv4()}>
          {needUpdate ? <ButtonPrimary handleClick={this.onhandleUpdate.bind(this)} title={"Обновить"} /> : null}
        </div>

        <Scrollbars ref="scrollbar" style={{ height: height + "px" }} autoHide={false}>
          {settingsGroup.map((setting, index) => {
            return (
              <div key={index} style={{ display: "flex" }}>
                <div className={styles.unitSettingItemBlock} style={styleColumn}>
                  {setting.left.dependents.length === 0 ? (
                    <CmsUnitSettingItem setting={setting.left.item} onHancleChange={this.onHancleChange.bind(this)} />
                  ) : (
                    <CmsUnitSettingGroupItem setting={setting.left} onHancleChange={this.onHancleChange.bind(this)} />
                  )}
                </div>

                {setting.middle === null ? null : (
                  <div className={styles.unitSettingItemBlock} style={styleColumn}>
                    {setting.middle.dependents.length === 0 ? (
                      <CmsUnitSettingItem setting={setting.middle.item} onHancleChange={this.onHancleChange.bind(this)} />
                    ) : (
                      <CmsUnitSettingGroupItem setting={setting.middle} onHancleChange={this.onHancleChange.bind(this)} />
                    )}
                  </div>
                )}

                {setting.rigth === null ? null : (
                  <div className={styles.unitSettingItemBlock} style={styleColumn}>
                    {setting.rigth.dependents.length === 0 ? (
                      <CmsUnitSettingItem setting={setting.rigth.item} onHancleChange={this.onHancleChange.bind(this)} />
                    ) : (
                      <CmsUnitSettingGroupItem setting={setting.rigth} onHancleChange={this.onHancleChange.bind(this)} />
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withUnits(CmsUnitSettings);
